import React from "react";
import Button from "Components/button/Button";
import PropTypes from "prop-types";

import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { province, allCountries } from "../../../config";
import dataTreatmentIt from "../../../static/dataTreatment-it.txt";
import dataTreatmentEn from "../../../static/dataTreatment-en.txt";
import privacyIt from "../../../static/privacy-it.txt";
import privacyEn from "../../../static/privacy-en.txt";
import termsIt from "../../../static/terms-it.txt";
import termsEn from "../../../static/terms-en.txt";
import _ from "lodash";
import TextArea from "Components/textArea/TextArea";
import RadioButton from "Components/radiobutton/RadioButton";
import Modal from "Components/smallModal/smallModal";
import WarningBanner from "Components/warningBanner/WarningBanner";
import SupportContactBox from "Components/supportContactBox/SupportContactBox";
import { warningFill } from "Icons/index";
import cx from "classnames";
import s from "./recap.scss";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
  router: PropTypes.object,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

export default class RecapStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isWarnModalOpened: false,
    };

    const paymentMethodFulls = {
      banktransfer: t("detailInfo.data.paymentType.bank"),
      lcwsoftpaypalbillingagreements: t("detailInfo.data.paymentType.paypalAuto"),
      paypal: t("detailInfo.data.paymentType.paypal"),
      stripe: t("detailInfo.data.paymentType.stripe"),
    };

    let state = {
      countryFull: _.filter(allCountries, {
        value: props.formData.country,
      })[0].label,
      paymentMethodFull: paymentMethodFulls[props.formData.payment_method],
    };

    // Get full name of the state
    if (props.formData.country === "IT") {
      state.stateFull = _.filter(province, {
        value: props.formData.state,
      })[0].label;
    }

    this.state = state;
  }

  openWarnModal = () => {
    this.setState({ isWarnModalOpened: true });
  };

  closeWarnModal = () => {
    this.setState({ isWarnModalOpened: false });
  };

  goBack = () => {
    this.props.goToStep(5);
  };

  toggleConditions = (val) => {
    let type = Object.keys(val)[0];
    let updatedField = {};

    if (type === "terms") updatedField.acceptedTerms = val.terms;
    if (type === "privacy") updatedField.acceptedPrivacy = val.privacy;
    if (type === "personalData") {
      updatedField.acceptedPersonalData = val.personalData;
    }

    this.setState(updatedField);
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({
      termsError: false,
      privacyError: false,
      personalDataError: false,
    });

    let errors = this.validateConditions();

    if (Object.keys(errors).length > 0) {
      this.setState(errors);
    } else {
      // submit form
      this.props.submitForm(e);
    }
  };

  validateConditions = () => {
    const { acceptedTerms, acceptedPrivacy, acceptedPersonalData } = this.state;

    let errors = {};
    if (acceptedTerms != "accept") {
      errors.termsError = t("errorMsg.accept");
    }

    if (acceptedPrivacy != "accept") {
      errors.privacyError = t("errorMsg.accept");
    }

    if (acceptedPersonalData != "accept") {
      errors.personalDataError = t("errorMsg.accept");
    }

    return errors;
  };

  render() {
    const {
      prices,
      MIN_MAILBOXES_NO,
      estimate,
      discountValue,
      formData: {
        domains,
        customer_type,
        billing_cycle,
        firstname,
        lastname,
        city,
        postcode,
        address1,
        state,
        phonenumber,
        companyname,
        vat,
        fiscalcode,
      },
      formErrors,
      isFormLoading,
      emailCounters,
    } = this.props;

    const { termsError, privacyError, personalDataError } = this.state;
    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG, getLoggedUser } = this.context;
    const lang = getLoggedUser().language;

    return (
      <form className="orderPage" onSubmit={this.submitForm}>
        {this.props.stepper}

        {!isMediaMobile() && !isMediaSM() && !isMediaMD() && <SupportContactBox className="supportBox" />}

        <div className={cx("sectionTitle", "titleFP")}>{t("order.add.title.step6")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc" />
          </div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              <div className="inputFull2">
                {billing_cycle === "monthly" && emailCounters.total < MIN_MAILBOXES_NO && (
                  <WarningBanner
                    color="blue"
                    msg={
                      <TranslatedString
                        subs={{
                          accountNumber: MIN_MAILBOXES_NO - emailCounters.total,
                        }}
                      >
                        infoMsg.order.minimum.monthly
                      </TranslatedString>
                    }
                  />
                )}
              </div>

              {billing_cycle === "monthly" ? (
                <div className="bg-[--bg] p-4 inputFull2">
                  {["basic", "professional", "enterprise"].map((plan) => {
                    if (!emailCounters[plan]) return null;

                    return Object.keys(emailCounters[plan]).map((gb) => {
                      if (!emailCounters[plan][gb] || emailCounters[plan][gb] === 0) return null;

                      return (
                        <div className="flex items-center justify-between mb-3">
                          <div className="basis-1/3">
                            <div className="text-sm">Email account {gb} GB</div>
                            <div className="text-xs text-[--text-a60]">
                              {t("orders.new.recap.price", {
                                price: prices[billing_cycle][`${plan}_${gb}`].toFixed(2),
                              })}
                            </div>
                          </div>

                          <div className="text-sm capitalize">{plan}</div>

                          <div className="text-sm font-bold">{emailCounters[plan][gb]}</div>
                        </div>
                      );
                    });
                  })}

                  {emailCounters.archive && emailCounters.archive > 0 ? (
                    <div className="flex items-center justify-between mb-3">
                      <div className="">
                        <div className="text-sm">Archivio email</div>
                        <div className="text-xs text-[--text-a60]">
                          {t("orders.new.recap.price", {
                            price: prices[billing_cycle][`basic_vault`].toFixed(2),
                          })}
                        </div>
                      </div>

                      <div className="text-sm font-bold">{emailCounters.archive}</div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {emailCounters.total < MIN_MAILBOXES_NO ? (
                    <div className="flex items-center justify-between bg-[--yellow] text-sm px-2 py-2">
                      <div className="font-bold">{t("orders.new.recap.addedForMinimum")}</div>

                      <div className="flex items-center gap-1">
                        <span className="font-bold">{MIN_MAILBOXES_NO - emailCounters.total} </span>
                        <span className="opacity-50">x € {prices[billing_cycle]["basic_8"].toFixed(2)}</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                domains.map((d) => {
                  return (
                    <div className={cx("inputFull2", s.bill)} key={d.name}>
                      <div className={cx(s.headerService, s.rowService)}>
                        <div className={s.nameService}> {d.name}</div>
                      </div>

                      <div className={s.rowService}>
                        <div className={s.nameService}>{t("table.header.plan")}</div>
                        <div className={s.dataService}>
                          <div className={s.numberService}>{d.new_plan}</div>
                        </div>
                      </div>

                      <div className={s.rowService}>
                        <div className={s.nameService}>{t("detailInfo.label.emailAccounts8gb")}</div>
                        <div className={s.dataService}>
                          <div className={s.numberService}>{d.new_8_count}</div>
                          <div className={s.priceService}>{prices[billing_cycle][`${d.new_plan}_8`].toFixed(2)}</div>
                        </div>
                      </div>

                      <div className={s.rowService}>
                        <div className={s.nameService}>{t("detailInfo.label.emailAccounts25gb")}</div>
                        <div className={s.dataService}>
                          <div className={s.numberService}>{d.new_25_count}</div>
                          <div className={s.priceService}>{prices[billing_cycle][`${d.new_plan}_25`].toFixed(2)}</div>
                        </div>
                      </div>

                      {d.new_plan !== "basic" && (
                        <div className={s.rowService}>
                          <div className={s.nameService}>{t("detailInfo.label.emailAccounts50gb")}</div>
                          <div className={s.dataService}>
                            <div className={s.numberService}>{d.new_50_count}</div>
                            <div className={s.priceService}>{prices[billing_cycle][`${d.new_plan}_50`].toFixed(2)}</div>
                          </div>
                        </div>
                      )}

                      <div className={s.rowService}>
                        <div className={s.nameService}>{t("detailInfo.label.archive")}</div>
                        <div className={s.dataService}>
                          <div className={s.numberService}>{d.new_archive_count}</div>
                          <div className={s.priceService}>
                            {prices[billing_cycle][`${d.new_plan}_vault`].toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}

              <div className={cx("inputFull2", s.rowBill)}>
                <div className={s.fee}>
                  <div>
                    {billing_cycle === "monthly"
                      ? t("order.label.first.bill.monthly")
                      : t("order.label.first.bill.annual")}
                  </div>
                  <div className={s.priceFee}>
                    {billing_cycle === "monthly" ? estimate : this.props.formData.annual_estimate}
                  </div>
                </div>

                {billing_cycle === "monthly" && <div className={s.infoFee}>{t("order.fee.invoiceCalc.monthly")}</div>}

                <div className={s.infoFee}>
                  * <TranslatedString>infoMsg.priceVat</TranslatedString>
                </div>
              </div>

              {customer_type === "reseller" && (
                <div className="inputFull2">
                  <WarningBanner info color="blue" msg={t("orders.new.recap.resellerWarn")} />
                </div>
              )}

              {/* recap anagrafica */}
              <div className={cx("inputFull2", "inputAddMargin", s.infoRecap)}>
                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.firstName")}</div>
                  <div className={s.dataInfoRecap}>{firstname}</div>
                </div>
                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.lastName")}</div>
                  <div className={s.dataInfoRecap}>{lastname}</div>
                </div>
                {customer_type !== "private" && (
                  <div className={s.rowInfoRecap}>
                    <div className={s.labelInfoRecap}>{t("detailInfo.label.company")}</div>
                    <div className={s.dataInfoRecap}>{companyname ? companyname : "–"}</div>
                  </div>
                )}

                {customer_type !== "private" && (
                  <div className={s.rowInfoRecap}>
                    <div className={s.labelInfoRecap}>{t("detailInfo.label.vat")}</div>
                    <div className={s.dataInfoRecap}>{vat}</div>
                  </div>
                )}

                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.fiscalcode")}</div>
                  <div className={s.dataInfoRecap}>{fiscalcode ? fiscalcode.toUpperCase() : "-"}</div>
                </div>

                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.address")}</div>
                  <div className={s.dataInfoRecap}>
                    {address1}, {postcode} {city}, {this.state.stateFull || state} {this.state.countryFull}
                  </div>
                </div>

                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.phonenumber")}</div>
                  <div className={s.dataInfoRecap}>{phonenumber}</div>
                </div>
              </div>

              <div className={cx("inputFull2", "inputAddMargin", s.infoRecap)}>
                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.account")}</div>
                  <div className={s.dataInfoRecap}>{t("detailInfo.label." + customer_type)}</div>
                </div>

                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.label.billingCycle")}</div>
                  <div className={s.dataInfoRecap}>
                    {billing_cycle === "monthly" ? t("select.value.monthly") : t("select.value.annually")}
                  </div>
                </div>

                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.lable.paymentType")}</div>
                  <div className={s.dataInfoRecap}>{this.state.paymentMethodFull}</div>
                </div>

                <div className={s.rowInfoRecap}>
                  <div className={s.labelInfoRecap}>{t("detailInfo.lable.billing.email")}</div>
                  <div className={s.dataInfoRecap}>{this.props.formData.email_address}</div>
                </div>
              </div>

              {/* terms and conditions */}
              <div className={cx("inputFull2", "inputAddMargin")}>
                <TextArea
                  className={s.textArea}
                  label={t("input.label.terms")}
                  value={lang === "it" ? termsIt : termsEn}
                  errors={termsError}
                  onlyRead
                />

                <div className={s.wrapRadioBtn}>
                  <RadioButton
                    className={s.radioBtn}
                    children={[
                      {
                        disabled: false,
                        value: "accept",
                        label: t("radiobtn.label.accept"),
                      },
                      {
                        disabled: false,
                        value: "noaccept",
                        label: t("radiobtn.label.noAccept"),
                      },
                    ]}
                    name="terms"
                    value={this.state.acceptedTerms}
                    onChange={this.toggleConditions}
                    inRow
                  />
                  {termsError && <div className={s.errorMsg}>{termsError}</div>}
                </div>
              </div>

              <div className={cx("inputFull2", "inputAddMargin")}>
                <TextArea
                  className={s.textArea}
                  label={t("input.label.privacy")}
                  value={lang === "it" ? privacyIt : privacyEn}
                  errors={privacyError}
                  onlyRead
                />

                <div className={s.wrapRadioBtn}>
                  <RadioButton
                    className={s.radioBtn}
                    children={[
                      {
                        disabled: false,
                        value: "accept",
                        label: t("radiobtn.label.accept"),
                      },
                      {
                        disabled: false,
                        value: "noaccept",
                        label: t("radiobtn.label.noAccept"),
                      },
                    ]}
                    name="privacy"
                    value={this.state.acceptedPrivacy}
                    onChange={this.toggleConditions}
                    inRow
                  />
                  {privacyError && <div className={s.errorMsg}> {privacyError} </div>}
                </div>
              </div>

              <div className={cx("inputFull2", "inputAddMargin")}>
                <TextArea
                  className={s.textArea}
                  label={t("input.label.personalData")}
                  value={lang === "it" ? dataTreatmentIt : dataTreatmentEn}
                  errors={personalDataError}
                  onlyRead
                />

                <div className={s.wrapRadioBtn}>
                  <RadioButton
                    className={s.radioBtn}
                    children={[
                      {
                        disabled: false,
                        value: "accept",
                        label: t("radiobtn.label.accept"),
                      },
                      {
                        disabled: false,
                        value: "noaccept",
                        label: t("radiobtn.label.noAccept"),
                      },
                    ]}
                    name="personalData"
                    value={this.state.acceptedPersonalData}
                    onChange={this.toggleConditions}
                    inRow
                  />
                  {personalDataError && <div className={s.errorMsg}>{personalDataError}</div>}
                </div>
              </div>

              {formErrors.onForm && (
                <div className="inputFull2">
                  <WarningBanner msg={formErrors.onForm} color="red" />
                </div>
              )}
            </div>
            <div className="footerFP">
              <Button onClick={this.openWarnModal} type="button" color="text" disabled={isFormLoading}>
                button.cancel
              </Button>
              <Button type="submit" color="green" loading={isFormLoading}>
                button.order
              </Button>
            </div>
          </div>
        </div>
        <Modal
          title={t("confirmationModal.title.delete.order")}
          icon={warningFill}
          iconClassName={s.iconModal}
          closeModal={this.closeWarnModal}
          opened={this.state.isWarnModalOpened}
        >
          <div>{t("confirmationModal.text.delete.order")}</div>
          <div>
            <Button color="text" onClick={this.closeWarnModal} type="button">
              button.backOrder
            </Button>
            <Button
              color="red"
              onClick={() => {
                this.props.resetForm();
                this.props.resetOrdersState();
                this.props.history.push("/orders");
              }}
              type="button"
            >
              button.delete
            </Button>
          </div>
        </Modal>
      </form>
    );
  }
}

RecapStep.contextTypes = ContextTypes;
